// extracted by mini-css-extract-plugin
export default {"tabs":"mBt9hU2a0W","full-width":"_1Ov0VcXXJr","fullWidth":"_1Ov0VcXXJr"};
    if(module.hot) {
      // 1625219498420
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  